import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const PrivateRoute = ({ children }) => {
  // Temporarily bypass authentication to allow access to profile page
  // const user = useSelector(state => state.auth.user);
  // return user ? children : <Navigate to="/login" />;
  
  // Always allow access for now
  return children;
};

export default PrivateRoute;
